"use client";

import React from "react";
import { ArrowRight, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
interface GuideItem {
  id: string;
  title: string;
  to: string;
  readTime: string;
}
const guides: GuideItem[] = [{
  id: "costi",
  title: "Quanto costa un impianto dentale in Albania nel 2026",
  to: "/quanto-costa-impianto-dentale-albania-2026/",
  readTime: "5 min"
}, {
  id: "preventivo",
  title: "Preventivo: cosa è incluso e cosa chiedere",
  to: "/preventivo-impianti-dentali-albania-cosa-include/",
  readTime: "4 min"
}, {
  id: "scelta-clinica",
  title: "Come scegliere una clinica dentale in Albania",
  to: "/come-scegliere-clinica-dentale-albania/",
  readTime: "6 min"
}, {
  id: "percorso",
  title: "Il percorso in 3 step, senza sorprese",
  to: "/il-percorso-in-3-step-per-ottenere-il-tuo-impianto-dentale-in-albania-senza-sorprese/",
  readTime: "4 min"
}, {
  id: "skydental",
  title: "SkyDental Tirana: come funziona il percorso",
  to: "/skydental-tirana-percorso-pazienti-italiani/",
  readTime: "5 min"
}, {
  id: "paure",
  title: "Le paure più comuni (e le risposte concrete)",
  to: "/paure-impianti-dentali-estero/",
  readTime: "6 min"
}, {
  id: "faq",
  title: "FAQ impianti dentali in Albania",
  to: "/faq-impianti-dentali-albania/",
  readTime: "7 min"
}, {
  id: "pro-e-contro",
  title: "Denti in Albania: pro e contro",
  to: "/denti-in-albania-pro-e-contro/",
  readTime: "5 min"
}, {
  id: "recensioni-negative",
  title: "Recensioni negative: come evitarle",
  to: "/recensioni-negative-dentisti-albania/",
  readTime: "5 min"
}, {
  id: "le-iene",
  title: "Le Iene e i denti in Albania: cosa chiedere",
  to: "/denti-albania-le-iene-cosa-chiedere/",
  readTime: "6 min"
}];
export default function PatientGuides() {
  return <section id="patientguides" data-nav="light" className="relative bg-background text-foreground py-16 sm:py-20 lg:py-24 border-t border-border/40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header Block */}
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-primary text-xs font-semibold uppercase tracking-wider mb-3">
            <BookOpen className="size-4" aria-hidden="true" />
            <span>Risorse informative</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-foreground font-serif">
            Guide per il paziente
          </h2>
          <p className="mt-3 text-base sm:text-lg text-muted-foreground leading-relaxed">
            Approfondimenti scritti per chi valuta un impianto dentale in Albania.
          </p>
        </div>

        {/* Guides Grid */}
        <div className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5">
          {guides.map((guide, index) => <Link key={guide.id} to={guide.to} data-index={index} className="group flex flex-col justify-between bg-card text-card-foreground p-5 sm:p-6 rounded-xl border border-border/80 shadow-xs hover:shadow-md hover:border-primary/40 hover:-translate-y-0.5 transition-all duration-200">
              <div>
                <div className="flex items-center justify-between text-xs text-muted-foreground mb-3">
                  <span className="font-mono text-primary/80 font-medium">Guida #{index + 1}</span>
                  <span>{guide.readTime}</span>
                </div>
                <h3 className="text-base sm:text-lg font-semibold text-foreground leading-snug group-hover:text-primary transition-colors">
                  {guide.title}
                </h3>
              </div>

              <div className="mt-6 pt-4 border-t border-border/50 flex items-center text-sm font-medium text-primary gap-1.5 group-hover:gap-2.5 transition-all">
                <span>Leggi la guida</span>
                <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}